module.exports = __webpack_public_path__ + "static/media/info08_Acude_a_la_JDE.8d3fb24c.png";